// Extra types measured in litres, so their quantity takes two decimals; every other type is a whole count.
// Types are inventory category names (e.g. "Fluid", "Fluids", "Oil & Fluids"), so match whole words.
const DECIMAL_QTY_TYPE = /\b(oil|fluids?)\b/i;

export const getExtraQtyInput = (type?: string | null) =>
  DECIMAL_QTY_TYPE.test(type || '') ? { step: 0.01, precision: 2 } : { step: 1, precision: 0 };
